<template>
  <NavBar :logged-in="isLoggedIn" />
  <Libraries />
</template>
<script>
import NavBar from "@/components/NavBar.vue";
import Libraries from "@/components/public/home/Libraries.vue";
import { authenticate, LOCAL_ACCESS_KEY } from "@/services";
import { LOAD_STORE_ACTION } from "@/store/constants.js";
import { Options, Vue } from "vue-class-component";
@Options({
  components: {
    NavBar,
    Libraries
  }
})
export default class Home extends Vue {
  isLoggedIn = false;
  loaded = false;

  async mounted() {
    const token = localStorage.getItem(LOCAL_ACCESS_KEY);
    this.isLoggedIn = token ? await authenticate(token) : false;
    if (this.isLoggedIn && !this.loaded) {
      await this.$store.dispatch(LOAD_STORE_ACTION);
      this.loaded = true;
    }
  }
}
</script>
